// src/pages/expense/business/ExpenseBusinessDraftList.jsx
// ✅ 전 사업 확산 [3] — 경영팀 "지출목록" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftList.jsx(공통 컴포넌트)에 있고, 이 파일은
// 경영팀 전용 config(businessDraftConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftList from "../_shared/ExpenseDraftList";
import businessDraftConfig from "./businessDraftConfig";

export default function ExpenseBusinessDraftList() {
  return <ExpenseDraftList config={businessDraftConfig} />;
}
